import { Permission, PermissionGroup } from '@fry/lib/permissions';

const permissions: Permission[] = [
  { id: 'dashboards.manage', name: $localize `Manage dashboards`, description: $localize `Allow user to edit dashboards`},
  { id: 'portals.manage', name: $localize `Manage bookings portals`, description: $localize `Allow user to edit bookings portals`},
];

export const dashboardsPermissions: PermissionGroup = {
  id: 'dashboards',
  name: $localize `Dashboards`,
  description: '',
  permissions
};